import '@omaze/omaze-ui/dist/omaze-ui.cjs.development.css';
import { ApolloProvider } from '@apollo/client';
import { App } from '@omaze/app';
import { getFeatureFlagModule } from '@omaze/feature';
import React  from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { createStore, IModuleStore } from 'redux-dynamic-modules';
import { getSagaExtension } from 'redux-dynamic-modules-saga';

import './index.css';

import { shopifyClient } from './data-sources/shopify-client/shopifyClient';
import { getEmailCaptureModule } from './footer/email-capture/email-capture-module/email-capture.module';
import { Footer } from './footer/public';
import { Article } from './pages/article/Article';
import { Auth0UnknownError } from './pages/auth0-unknown-error/Auth0UnknownError.component';
import { Cart } from './pages/cart/Cart';
import { Collection } from './pages/collection/Collection';
import { Experience } from './pages/experience/Experience';
import { Homepage } from './pages/homepage/Homepage';
import { NotFound } from './pages/not-found/NotFound';

const store: IModuleStore<any> = createStore(
    {
        extensions: [getSagaExtension()],
    },
    getFeatureFlagModule(),
);

function bootstrapApp (): void {
    ReactDOM.render((
        <Provider store={store}>
            <ApolloProvider client={shopifyClient}>
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/">
                            <Homepage />
                        </Route>
                        <Route path="/blogs/impact/:slug">
                            <Article />
                        </Route>
                        <Route path="/collections/:slug">
                            <Collection/>
                        </Route>
                        <Route path="/pages/account-services-error">
                            <Auth0UnknownError />
                        </Route>
                        <Route path="/products/:slug">
                            <Experience />
                        </Route>
                        <Route path="/cart">
                            <Cart />
                        </Route>
                        <Route path="*">
                            <NotFound />
                        </Route>
                    </Switch>
                </BrowserRouter>
                <App
                    featureFlags={{}}
                    modules={[
                        getEmailCaptureModule(),
                    ]}
                >
                    <Footer />
                </App>
            </ApolloProvider>
        </Provider>
    ), document.getElementById('js-shopify-app__root'));
}

bootstrapApp();
